import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { paymentPagesFetchGet } from '../../../../api-client/api-gqadmin-client';

const initialState = {
    loading: false,
    error: null,
    data: null,
};

export const getPaymentPagesFetch = createAsyncThunk(
    'getPaymentPagesFetch/Get',
    async (body, { rejectWithValue }) => {
        try {
            const response = await paymentPagesFetchGet(body);
            const data = response?.data;
            return data;
        } catch (err) {
            const errObj = {
                type: 'GET_GQ_ADMIN_PAYMENT_PAGES_FETCH_DETAILS_FAILURE',
                error: err,
                message: 'Oops! something went wrong',
            };
            return rejectWithValue(err?.response?.data || errObj);
        }
    },
);

const getPaymentPagesFetchSlice = createSlice({
    name: 'getPaymentPagesFetch',
    initialState,
    extraReducers: {
        [getPaymentPagesFetch.pending]: (state) => {
            state.loading = true;
        },
        [getPaymentPagesFetch.fulfilled]: (state, { payload }) => {
            state.loading = false;
            state.data = payload?.data;
            state.error = null;
        },
        [getPaymentPagesFetch.rejected]: (state, { payload }) => {
            state.loading = false;
            state.data = null;
            state.error = payload;
        },
    },
});

export const getPaymentPagesFetchSelector = (state) => state.getPaymentPagesFetch;
export const getPaymentPagesFetchReducer = getPaymentPagesFetchSlice.reducer;
